<template>
    <div class="form__checkbox">
        <input
            :id="compId"
            type="checkbox"
            class="field"
            :checked="modelValue"
            v-bind="$attrs"
            @change="$emit('update:modelValue', $event.target.checked)"
            :class="{'has-error': error}"
        />
        <label
            v-if="label"
            :for="compId"
            v-html="parsedLabel"
        />
        <p
            v-if="error"
            :id="`${compId}-error`"
            class="form__error"
            aria-live="assertive"
        >
            {{ error }}
        </p>
    </div>
</template>

<script setup>
import {computed, useId} from 'vue'

const compId = 'field-' + useId()
const props = defineProps({
    label: {
        type: String,
        required: true,
    },
    labelLink: {
        type: String,
        required: false,
    },
    modelValue: {
        type: Boolean,
        default: false,
    },
    error: {
        type: String,
        default: ''
    }
})

const parsedLabel = computed(() => {
    if (!props.labelLink) {
        return props.label.replace(/\{([^}]+)}/g, '$1')
    }

    // Ersetze Text in geschweiften Klammern durch einen Link
    return props.label.replace(/\{([^}]+)}/g, (match, linkText) => {
        return `<a href="${props.labelLink}" target="_blank" rel="noopener noreferrer">${linkText}</a>`
    })
})

</script>
